<mat-list class="search-menu-sort common-search-menu {{viewName}}">
  <mat-radio-group [value]="searchContainer.getOrder()">
    @for (s of displayedSortOrderMenus; track s[AConst.ORDER]) {
      <button
        mat-menu-item
        [ngClass]="{'active':searchContainer.getOrder() === s[AConst.ORDER]}"
      >
        <mat-radio-button
          [value]="s[AConst.ORDER]"
          (click)="changeSortOrder(s)"
          (keydown)="null"
        >
          <span class="common-search-menu__radio-text">
            {{ s.description | translate }}
          </span>
        </mat-radio-button>
      </button>
    }
  </mat-radio-group>
</mat-list>
